import { useContext, useMemo } from 'react';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';
import { isPackVisibleInExtranet } from 'app/utils/extranet';

export const useFilteredPackages = () => {
  const { packsList, publishedRooms, isLoading } =
    useContext(ModernHotelContext);

  const filteredNightStayPacks = useMemo(() => {
    return packsList.filter((pack) => {
      const isNightStay = !pack.isDaytime;

      const hasPublishedRoom = (pack.packRooms ?? []).some((packRoom) =>
        publishedRooms.some((room) => room.id === packRoom.roomId)
      );

      return (
        isPackVisibleInExtranet(pack.status) && isNightStay && hasPublishedRoom
      );
    });
  }, [packsList, publishedRooms]);

  const filteredDaytimePacks = useMemo(() => {
    return packsList.filter(
      (pack) => isPackVisibleInExtranet(pack.status) && pack.isDaytime
    );
  }, [packsList]);

  return {
    filteredNightStayPacks,
    filteredDaytimePacks,
    isLoading,
  };
};
